export default __webpack_public_path__ + "static/media/img_02.7308cf49.png";